import { APIError } from 'ck-global-types';
import { toast } from 'react-hot-toast';

export const errorHandler = (err: unknown) => {
  if (err instanceof APIError) {
    // Always show clientMessage if it exists.
    // { id } deduplicates identical toasts in case the same error fires
    // from multiple simultaneous sources.
    if (err.clientMessageSwedish) {
      toast.error(err.clientMessageSwedish, { id: err.clientMessageSwedish });
    }

    // Show extra toast for every type of error provided
    if (err.errors) {
      Object.entries(err.errors).forEach((e) => {
        const msg = e[1].join(', ');
        toast.error(msg, { id: msg });
      });
    }

    return;
  }

  // Since we conform all errors to APIError this should never happen
  toast.error(`Något gick fel: ${err}`, { id: 'generic-error' });
};
